import { ViewerAddPinType } from "components/containers/inspectionDetail/context/inspectionDetailReducer";
import { sort } from "components/containers/inspectionSetting/containers/templateBuilder/helpers/func";

import {
  ADD_PIN_VIEWER_TYPE,
  INSPECTION_GROUP_LAST_SELECTED_VIEW,
  MAX_KEEP_ADD_PIN_VIEW_ROLE,
  MAX_KEEP_SELECTED_VIEW_BY_GROUP,
} from "constants/inspection";
import { InspectionItem } from "interfaces/models/inspectionItem";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import { Pin, PinDTO } from "interfaces/models/pin";
import { groupByKey } from "utils/array";
import { getLocalStorage } from "utils/storage";

type AddPinViewerType = {
  inspectionTypeId: string;
  type: ViewerAddPinType;
};

type InspectionGroupSelectedView = {
  inspectionGroupId: string;
  viewGuid: string;
};

export enum QueryStatus {
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  QUEUED = "QUEUED",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
}

export interface QueryExecution {
  s3Url: string | null | undefined;
  executionId: string;
  status: QueryStatus;
}

export function transformItemAndItemResults(params: {
  items: InspectionItem[];
  itemResults: InspectionItemResult[];
}) {
  const { items, itemResults } = params;

  const sortItems = sort(items || []);
  const groupItemResultByItemId = groupByKey(itemResults, "contentItemId");
  const sortItemResults: InspectionItemResult[] = [];
  sortItems.forEach((item) => {
    sortItemResults.push(...(groupItemResultByItemId?.[item.id] || []));
  });

  return { items: sortItems, itemResults: sortItemResults };
}

export function getPinsOfGroup(pins: Pin[], pinGroupId: string): PinDTO[] {
  const dtoPins: PinDTO[] = [];
  for (const pin of pins) {
    const pinGroup = pin.pinGroups?.find(
      (node) => node.pinGroupId === pinGroupId
    );
    if (pinGroup) {
      const { order } = pinGroup;
      dtoPins.push({
        ...pin,
        order,
        pinGroupId,
      });
    }
  }

  return sort(dtoPins);
}

export function changeViewerAddPinType(
  inspectionTypeId: string,
  type: ViewerAddPinType
) {
  const addPinViewerTypes = getLocalStorage(
    ADD_PIN_VIEWER_TYPE,
    []
  ) as AddPinViewerType[];
  const addPinViewerType = addPinViewerTypes.find(
    (item) => item.inspectionTypeId === inspectionTypeId
  );
  if (!addPinViewerType) {
    if (addPinViewerTypes.length >= MAX_KEEP_ADD_PIN_VIEW_ROLE) {
      addPinViewerTypes.shift();
    }
    addPinViewerTypes.push({
      inspectionTypeId,
      type,
    });
  } else {
    addPinViewerType.type = type;
  }
  localStorage.setItem(ADD_PIN_VIEWER_TYPE, JSON.stringify(addPinViewerTypes));
}

export function getViewerAddPinType(inspectionTypeId: string) {
  const addPinViewRoles = getLocalStorage(
    ADD_PIN_VIEWER_TYPE,
    []
  ) as AddPinViewerType[];
  const addPinViewRole = addPinViewRoles.find(
    (item) => item.inspectionTypeId === inspectionTypeId
  );

  return addPinViewRole?.type;
}

export function changeSelectedViewOfGroup(
  inspectionGroupId: string,
  viewGuid: string
) {
  const groupSelectedViews = getLocalStorage(
    INSPECTION_GROUP_LAST_SELECTED_VIEW,
    []
  ) as InspectionGroupSelectedView[];
  const selectedView = groupSelectedViews.find(
    (item) => item.inspectionGroupId === inspectionGroupId
  );
  if (selectedView) {
    selectedView.viewGuid = viewGuid;
  } else {
    if (groupSelectedViews.length >= MAX_KEEP_SELECTED_VIEW_BY_GROUP) {
      groupSelectedViews.shift();
    }
    groupSelectedViews.push({
      inspectionGroupId,
      viewGuid,
    });
  }
  localStorage.setItem(
    INSPECTION_GROUP_LAST_SELECTED_VIEW,
    JSON.stringify(groupSelectedViews)
  );
}

export function getLastSelectedViewByGroup(inspectionGroupId: string) {
  const groupSelectedViews = getLocalStorage(
    INSPECTION_GROUP_LAST_SELECTED_VIEW,
    []
  ) as InspectionGroupSelectedView[];
  const addPinViewRole = groupSelectedViews.find(
    (item) => item.inspectionGroupId === inspectionGroupId
  );

  return addPinViewRole?.viewGuid;
}
